// @flow

import { getApiBaseUrlByTenantCode, type TenantCode } from '@tectonics/commons/tenant';
import type { QueryResponse, CompleteResponse, CompleteRequest } from '../types';

export const QUERY_ERROR_MESSAGE = 'No pudimos cargar la información de tu pago. Inténtalo de nuevo.';
export const COMPLETE_ERROR_MESSAGE = 'No pudimos completar tu pago. Inténtalo de nuevo.';
export const PAYMENT_NOT_PENDING_CODE = 'BP-PA-05';

type JsonBody = { +status_message?: string };

async function readJsonBody(response: Response): Promise<JsonBody> {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

async function fetchJson<T>(
  url: string,
  fallbackMessage: string,
  options: RequestOptions,
): Promise<T> {
  let response;

  try {
    response = await fetch(url, options);
  } catch {
    throw new Error(fallbackMessage);
  }

  const body = await readJsonBody(response);

  if (!response.ok) {
    throw new Error(body.status_message || fallbackMessage);
  }

  // $FlowFixMe - the endpoint contract guarantees the parsed body matches T
  return body;
}

export async function queryHostedPayment(
  paymentHash: string,
  tenantCode: TenantCode,
): Promise<QueryResponse> {
  const baseUrl = getApiBaseUrlByTenantCode(tenantCode);

  return fetchJson(
    `${baseUrl}cf/hosted-payment/query?hash=${encodeURIComponent(paymentHash)}`,
    QUERY_ERROR_MESSAGE,
    { method: 'GET' },
  );
}

export async function completeHostedPayment(
  paymentHash: string,
  phone: string,
  tenantCode: TenantCode,
): Promise<CompleteResponse> {
  const baseUrl = getApiBaseUrlByTenantCode(tenantCode);

  const payload: CompleteRequest = {
    hash: paymentHash,
    phone,
  };

  return fetchJson(
    `${baseUrl}cf/hosted-payment/complete`,
    COMPLETE_ERROR_MESSAGE,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}
